<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    #stepper
    [nextButtonLabels]="nextButtonLabels"
    [textForSendButton]="'studentPaymentV2:generatePaymentLink'"
    [sendIn]="'penultimate'"
    (send)="submit()"
    [validations]="validations">
    <ew-mat-stepper-custom-step>
      <div class="flex flex-wrap">
        <h1 class="w-full text-4xl font-bold">
          {{ 'studentPaymentV2:title' | translate }}
        </h1>
        <h2 class="mb-5 font-medium text-gray-500">
          {{ 'studentPaymentV2:subTitle' | translate }}
        </h2>
      </div>
      <div class="flex flex-col justify-center">
        <form [formGroup]="payer">
          <ew-select-country
            [width]="'100%'"
            [label]="'studentPaymentV2:payersCountry'"
            [isAvailableToSendPayment]="true"
            (valueChanged)="
              payer.patchValue({ country: $event.iso }); onPayerCountryChange()
            "></ew-select-country>
          <ew-input-language
            [width]="'100%'"
            [label]="'studentPaymentV2:paymentLinkLanguage' | translate"
            (valueChanged)="
              payer.patchValue({ language: $event })
            "></ew-input-language>
          <div
            class="cursor-pointer text-blue-500 mb-4"
            (click)="hidePayerDetails = !hidePayerDetails">
            {{
              (hidePayerDetails
                ? 'createRequestMoney:addPayerDetails'
                : 'createRequestMoney:hidePayerDetails'
              ) | translate
            }}
            <i
              class="mr-2 fa-solid fa-caret-right"
              [class.fa-rotate-90]="!hidePayerDetails"></i>
          </div>
          <ng-container *ngIf="!hidePayerDetails">
            <mat-form-field class="w-full">
              <mat-label>
                {{ 'agencyPaymentRequest:whoIsMakingThePayment' | translate }}
                <small class="text-gray-400"
                  >({{ 'shared:optional' | translate }})</small
                >
              </mat-label>
              <mat-select
                formControlName="whoIsMakingThePayment"
                (selectionChange)="(null)">
                <mat-option value="STUDENT">{{
                  'createRequestMoney:payerInputWhoIsMakingThePaymentOptionSTUDENT'
                    | translate
                }}</mat-option>
                <mat-option value="FATHER">{{
                  'createRequestMoney:payerInputWhoIsMakingThePaymentOptionFATHER'
                    | translate
                }}</mat-option>
                <mat-option value="MOTHER">{{
                  'createRequestMoney:payerInputWhoIsMakingThePaymentOptionMOTHER'
                    | translate
                }}</mat-option>
                <mat-option value="RELATIVE">{{
                  'createRequestMoney:payerInputWhoIsMakingThePaymentOptionRELATIVE'
                    | translate
                }}</mat-option>
                <mat-option value="EDUCATION_AGENT">{{
                  'createRequestMoney:payerInputWhoIsMakingThePaymentOptionEDUCATION_AGENT'
                    | translate
                }}</mat-option>
                <mat-option value="OTHER">{{
                  'createRequestMoney:payerInputWhoIsMakingThePaymentOptionOTHER'
                    | translate
                }}</mat-option>
              </mat-select>
              <mat-error *ngIf="payer.controls['whoIsMakingThePayment'].errors">
                <span>{{
                  'createRequestMoney:payerInputWhoIsMakingThePayment'
                    | translate
                }}</span
                ><strong> {{ 'shared:isRequired' | translate }}</strong>
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full" *ngIf="isDocumentRequiredForPayer">
              <mat-label>
                {{ documentLabel }}
                <small>({{ 'shared:optional' | translate }})</small>
              </mat-label>
              <input
                matInput
                formControlName="document"
                name="document"
                [placeholder]="documentExample"
                [mask]="documentMask ?? null"
                [dropSpecialCharacters]="false" />
              <mat-error *ngIf="payer.controls['document'].errors">
                <span *ngIf="payer.controls['document'].errors['pattern']"
                  >{{ documentLabel }}
                  <strong>
                    {{ 'shared:formatIncorrect' | translate }} (ex.:
                    {{ documentExample }})</strong
                  ></span
                >
              </mat-error>
            </mat-form-field>

            <div class="mb-6" *ngIf="isPassportRequiredForPayer()">
              <ew-upload-documents
                uploader
                [required]="false"
                [isIncludedInsideMatForm]="true"
                [isProofOfPayment]="false"
                [buttonTextUpload]="'paymentRequest:uploadPassport' | translate"
                [files]="payerPassportToUpload"
                [acceptedTypes]="['image/jpg', 'image/png', 'application/pdf']"
                [maxSize]="25_000_000"
                [noAuthUpload]="false"
                [uploadedDocumentsIds]="payerUploadedPassportId"
                (documentsUploaded)="handlePayerPassportUpload()"
                (valueChanged)="handlePayerPassportFileSelection($event)"></ew-upload-documents>
            </div>

            <ng-container
              *ngIf="
                payer.value.whoIsMakingThePayment &&
                payer.value.whoIsMakingThePayment !== 'STUDENT'
              ">
              <div class="flex flex-col justify-center">
                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputName' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="firstname"
                    name="firstname"
                    placeholder="" />
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputSurname' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="lastname"
                    name="lastname"
                    placeholder="" />
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputCity' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="city"
                    name="city"
                    placeholder="" />
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputAddress' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="address"
                    name="address"
                    placeholder="" />
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputPostalCode' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="postalCode"
                    name="postalCode"
                    placeholder="" />
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputEmail' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="email"
                    name="email"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['email'].errors">
                    <span *ngIf="payer.controls['email'].errors['email']">{{
                      'shared:formatEmail' | translate
                    }}</span>
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label>
                    {{ 'createRequestMoney:payerInputPhoneNumber' | translate }}
                    <small>({{ 'shared:optional' | translate }})</small>
                  </mat-label>
                  <input
                    matInput
                    formControlName="phoneNumber"
                    name="phoneNumber"
                    placeholder="" />
                  <mat-error *ngIf="payer.controls['phoneNumber'].errors">
                    <span
                      *ngIf="payer.controls['phoneNumber'].errors['minlength']">
                      {{
                        payer.controls['phoneNumber'].errors['minlength']
                          | errorMinValue
                      }}
                    </span>

                    <span
                      *ngIf="payer.controls['phoneNumber'].errors['maxlength']">
                      {{
                        payer.controls['phoneNumber'].errors['maxlength']
                          | errorMaxValue
                      }}
                    </span>

                    <span
                      *ngIf="payer.controls['phoneNumber'].errors['pattern']">
                      {{ 'shared:formatIncorrect' | translate }}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </ng-container>
          </ng-container>
        </form>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="flex flex-wrap">
        <h1 class="w-full text-4xl font-bold">
          {{ 'paymentRequest:invoiceDetails' | translate }}
        </h1>
        <h2 class="mb-5 font-medium text-gray-500">
          {{ 'paymentRequest:invoiceDetailsDescription' | translate }}
        </h2>
      </div>
      <div class="flex flex-col justify-center">
        <form class="grid gap-2" [formGroup]="order">
          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              {{ 'studentPayemntV2:educationProviderName' | translate }}
              <small class="text-gray-400"
                >({{ 'shared:required' | translate }})</small
              >
            </mat-label>
            <input
              matInput
              required
              formControlName="providerName"
              name="providerName"
              placeholder="" />
            <mat-error *ngIf="order.controls['providerName'].errors">
              <strong> {{ 'shared:isRequired' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              {{ 'paymentRequest:invoiceId' | translate }}
              <small class="text-gray-400"
                >({{ 'shared:required' | translate }})</small
              >
            </mat-label>
            <input
              matInput
              required
              formControlName="orderId"
              name="orderId"
              placeholder="" />
            <mat-error *ngIf="order.controls['orderId'].errors">
              <strong> {{ 'shared:isRequired' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <ew-upload-documents
            *ngIf="isInvoiceRequired()"
            uploader
            [isIncludedInsideMatForm]="true"
            [isProofOfPayment]="false"
            [required]="isInvoiceRequired()"
            [buttonTextUpload]="'paymentRequest:uploadInvoice' | translate"
            [infoDialog]="'studentPayemntV2:invoiceInfoDialog' | translate"
            [files]="invoiceToUpload"
            [acceptedTypes]="[
              'image/jpg',
              'image/jpeg',
              'image/png',
              'application/pdf'
            ]"
            [maxSize]="25_000_000"
            [noAuthUpload]="payer.get('country')?.value !== 'br'"
            [uploadedDocumentsIds]="uploadedInvoiceId"
            (documentsUploaded)="handleInvoiceUpload()"
            (valueChanged)="handleInvoiceFileSelection($event)"></ew-upload-documents>
        </form>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="flex flex-wrap">
        <h1 class="w-full text-4xl font-bold">
          {{ 'studentPaymentV2:studentDetails' | translate }}
        </h1>
        <h2 class="mb-5 font-medium text-gray-500">
          {{ 'studentPaymentV2:studentDetailsSubTitle' | translate }}
        </h2>
      </div>

      <div class="flex flex-col justify-center">
        <form class="grid gap-2" [formGroup]="student">
          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              {{ 'studentPaymentV2:studentName' | translate }}

              <small class="text-gray-400"
                >({{ 'shared:required' | translate }})</small
              >
            </mat-label>
            <input
              matInput
              required
              formControlName="firstname"
              name="firstname"
              placeholder="" />
            <mat-error *ngIf="student.controls['firstname'].errors">
              <span *ngIf="student.controls['firstname'].errors['required']">
                <strong> {{ 'shared:isRequired' | translate }}</strong>
              </span>

              <span *ngIf="student.controls['firstname'].errors['maxlength']">
                {{
                  student.controls['firstname'].errors['maxlength']
                    | errorMaxValue
                }}</span
              >
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label class="font-semibold mb-2">
              {{ 'studentPaymentV2:studentLastName' | translate }}
              <small class="text-gray-400"
                >({{ 'shared:required' | translate }})</small
              >
            </mat-label>
            <input
              matInput
              required
              formControlName="lastname"
              name="lastname"
              placeholder="" />
            <mat-error *ngIf="student.controls['lastname'].errors">
              <span *ngIf="student.controls['lastname'].errors['required']">
                <strong> {{ 'shared:isRequired' | translate }}</strong>
              </span>

              <span *ngIf="student.controls['lastname'].errors['maxlength']">
                {{
                  student.controls['lastname'].errors['maxlength']
                    | errorMaxValue
                }}</span
              >
            </mat-error>
          </mat-form-field>

          <ew-select-country
            [width]="'100%'"
            [label]="'studentPaymentV2:country'"
            (valueChanged)="onCountryChange($event)"
            [required]="false"
            [value]="payer.controls['country'].value"></ew-select-country>
        </form>
      </div>

      <span
        class="cursor-pointer text-blue-500"
        (click)="hideStudentDetails = !hideStudentDetails">
        {{
          (hideStudentDetails
            ? 'studentPaymentV2:showDetails'
            : 'studentPaymentV2:hideDetails'
          ) | translate
        }}
        <i
          class="mr-2 fa-solid fa-caret-right"
          [class.fa-rotate-90]="!hideStudentDetails"></i>
      </span>

      <!-- More student details -->
      <ng-container *ngIf="!hideStudentDetails">
        <div class="flex flex-col justify-center mt-4">
          <form class="grid gap-2" [formGroup]="student">
            <!-- externalId -->
            <mat-form-field>
              <mat-label class="flex font-semibold mb-2">
                {{ 'studentPaymentV2:externalID' | translate }}

                <i
                  class="fa-solid fa-circle-info ml-2 text-blue-500"
                  matTooltip="{{
                    'studentPaymentV2:externalIDToolTip' | translate
                  }}"
                  [matTooltipPosition]="'above'"></i>
              </mat-label>
              <input
                matInput
                formControlName="externalId"
                name="externalId"
                placeholder="" />
            </mat-form-field>

            <!-- email  -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'studentPaymentV2:email' | translate }}
              </mat-label>
              <input
                matInput
                formControlName="email"
                name="email"
                placeholder="" />
              <mat-error *ngIf="student.controls['email'].errors">
                <span>
                  <strong> {{ 'shared:formatEmail' | translate }}</strong>
                </span>
              </mat-error>
            </mat-form-field>

            <!-- phone number -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'studentPaymentV2:mobile' | translate }}
              </mat-label>
              <input
                matInput
                formControlName="mobile"
                name="mobile"
                placeholder="" />
              <mat-error *ngIf="student.controls['mobile'].errors">
                <span *ngIf="student.controls['mobile'].errors['minlength']">
                  {{
                    student.controls['mobile'].errors['minlength']
                      | errorMinValue
                  }}
                </span>

                <span *ngIf="student.controls['mobile'].errors['maxlength']">
                  {{
                    student.controls['mobile'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>

                <span *ngIf="student.controls['mobile'].errors['pattern']">
                  {{ 'shared:formatIncorrect' | translate }}
                </span>
              </mat-error>
            </mat-form-field>

            <!-- city -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'studentPaymentV2:studentCity' | translate }}
              </mat-label>
              <input
                matInput
                formControlName="city"
                name="city"
                placeholder="" />
              <mat-error *ngIf="student.controls['city'].errors">
                <span *ngIf="student.controls['city'].errors['minlength']">
                  {{
                    student.controls['city'].errors['minlength'] | errorMinValue
                  }}
                </span>

                <span *ngIf="student.controls['city'].errors['maxlength']">
                  {{
                    student.controls['city'].errors['maxlength'] | errorMaxValue
                  }}</span
                >
              </mat-error>
            </mat-form-field>

            <!-- address -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'studentPaymentV2:studentAddress' | translate }}
              </mat-label>
              <input
                matInput
                formControlName="address"
                name="address"
                placeholder="" />

              <mat-error *ngIf="student.controls['address'].errors">
                <span *ngIf="student.controls['address'].errors['minlength']">
                  {{
                    student.controls['address'].errors['minlength']
                      | errorMinValue
                  }}
                </span>
                <span *ngIf="student.controls['address'].errors['maxlength']">
                  {{
                    student.controls['address'].errors['maxlength']
                      | errorMaxValue
                  }}</span
                >
              </mat-error>
            </mat-form-field>

            <!-- zip code -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'studentPaymentV2:studentPostalCode' | translate }}
              </mat-label>
              <input
                matInput
                formControlName="zipCode"
                name="zipCode"
                placeholder="" />

              <mat-error *ngIf="student.controls['zipCode'].errors">
                <span *ngIf="student.controls['zipCode'].errors['minlength']">
                  {{
                    student.controls['zipCode'].errors['minlength']
                      | errorMinValue
                  }}
                </span>

                <span>
                  {{
                    student.controls['zipCode'].errors['maxlength']
                      | errorMaxValue
                  }}</span
                >
              </mat-error>
            </mat-form-field>

            <!-- birth date -->
            <mat-form-field>
              <mat-label class="font-semibold mb-2">
                {{ 'studentPaymentV2:studentBirthDate' | translate }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="dateOfBirth"
                (click)="picker.open()" />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker
                #picker
                color="primary"
                startView="multi-year"
                [startAt]="startDate"></mat-datepicker>
            </mat-form-field>

            <ew-upload-documents
              *ngIf="isPassportRequiredForStudent()"
              uploader
              [required]="false"
              [isIncludedInsideMatForm]="true"
              [isProofOfPayment]="false"
              [buttonTextUpload]="'paymentRequest:uploadPassport' | translate"
              [files]="passportToUpload"
              [acceptedTypes]="[
                'image/jpg',
                'image/jpeg',
                'image/png',
                'application/pdf'
              ]"
              [maxSize]="25_000_000"
              [noAuthUpload]="false"
              [uploadedDocumentsIds]="uploadedPassportId"
              (documentsUploaded)="handlePassportUpload()"
              (valueChanged)="handleStudentPassportFileSelection($event)"></ew-upload-documents>
          </form>
        </div>
      </ng-container>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="flex flex-wrap">
        <h1 class="w-full text-4xl font-bold">
          {{ 'studentPaymentV2:currencyTitle' | translate }}
        </h1>
        <h2 class="mb-5 font-medium text-gray-500">
          {{ 'studentPaymentV2:currencySubtitle' | translate }}
        </h2>
      </div>

      <div class="flex flex-col justify-center">
        <form class="grid gap-2" [formGroup]="payment">
          <mat-form-field>
            <mat-label class="font-semibold">
              {{ 'studentPaymentV2:currencyAccounts' | translate }}
              <small class="text-gray-400">
                ({{ 'shared:required' | translate }})
              </small>
            </mat-label>

            <mat-select
              [class.h-16]="payment.get('currencyAccount')?.value !== null"
              formControlName="currencyAccount"
              required="true">
              <mat-select-trigger
                *ngIf="payment?.get('currencyAccount')?.value !== null">
                <div class="flex items-center">
                  <img
                    class="object-cover w-10 h-10 rounded-full mr-4"
                    src="https://flagcdn.com/{{
                      payment.get('currencyAccount')?.value.currencyIso
                        | currencyCountry
                    }}.svg"
                    [alt]="
                      'Currency flag for ' +
                      payment.get('currencyAccount')?.value.currencyIso
                    "
                    loading="lazy" />

                  <div class="flex flex-col">
                    <span>
                      {{ payment.get('currencyAccount')?.value.currencyIso }}
                    </span>
                    <span class="text-gray-400">
                      {{ 'studentPaymentV2:currentBalance' | translate }}
                      {{
                        payment.get('currencyAccount')?.value.balance | currency
                      }}
                    </span>
                  </div>
                </div>
              </mat-select-trigger>

              <mat-option [value]="item" *ngFor="let item of currencyAccounts">
                <div class="flex items-center">
                  <img
                    class="object-cover w-6 h-6 rounded-full mr-2"
                    src="https://flagcdn.com/{{
                      item.currencyIso | currencyCountry
                    }}.svg"
                    width="36"
                    height="27"
                    [alt]="'Currency flag for ' + item.currencyIso"
                    loading="lazy" />
                  {{ item.currencyIso }}
                </div>
              </mat-option>
            </mat-select>

            <mat-error *ngIf="payment.controls['currencyAccount'].errors">
              <strong> {{ 'shared:isRequired' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <div class="flex-col my5">
            <label class="text-sm font-semibold" for="amount">
              {{ 'studentPaymentV2:amountToReceive' | translate }}
            </label>

            <div class="flex">
              <span class="flex font-bold text-5xl mr-4 mt-1">
                {{
                  getCurrencySymbol(
                    payment.get('currencyAccount')?.value?.currencyIso
                  )
                }}
              </span>
              <input
                ewPreventScroll
                matInput
                class="flex font-bold text-5xl no-arrows"
                mask="separator.2"
                thousandSeparator=","
                decimalMarker="."
                name="amount"
                formControlName="amount"
                placeholder=".01"
                step="0.01"
                min="0.01"
                max="5000000"
                required />
            </div>
            <div class="flex">
              <span class="text-sm text-gray-400">
                {{ 'studentPaymentV2:futureBalance' | translate }}
              </span>
              <span
                class="inline-flex items-center text-sm font-bold ml-2"
                *ngIf="payment.get('amount')?.value !== null">
                {{ futureBalance | currency }}
              </span>
            </div>

            <!-- Custom spread info box -->
            <div
              *ngIf="
                payment.get('currencyAccount')?.value?.spread && !showSpreadForm
              "
              class="w-full bg-blue-50 border border-blue-200 rounded-md p-4 mt-3 mb-3">
              <div class="flex items-start">
                <i class="fa-solid fa-circle-info mr-2 text-blue-500"></i>
                <p class="text-sm">
                  {{
                    'editCustomSpread:studentPaymentInfo'
                      | translate
                        : {
                            spreadValue:
                              payment.get('currencyAccount')?.value?.spread
                          }
                  }}
                  <span
                    class="text-blue-500 cursor-pointer hover:underline ml-2"
                    (click)="toggleSpreadForm()">
                    {{ 'shared:edit' | translate }}
                  </span>
                </p>
              </div>
            </div>

            <!-- Custom spread form - shown when Edit is clicked -->
            <div *ngIf="showSpreadForm" class="w-full mt-3 mb-3">
              <form [formGroup]="spreadForm">
                <div class="mb-6">
                  <label class="text-sm font-semibold" for="spread">
                    {{ 'editCustomSpread:yourNewSpread' | translate }}
                  </label>

                  <div class="flex">
                    <input
                      class="font-bold text-5xl no-arrows w-[5ch]"
                      mask="separator.2"
                      thousandSeparator=""
                      decimalMarker="."
                      prefix=""
                      suffix=""
                      numericInput="true"
                      [dropSpecialCharacters]="false"
                      name="spread"
                      formControlName="spread"
                      placeholder="0.00"
                      step="0.01"
                      min="{{ minSpread }}"
                      max="{{ maxSpread }}"
                      required />
                    <span class="flex font-bold text-5xl ml-1 mt-1">%</span>
                  </div>

                  <div class="flex mt-1">
                    <div
                      *ngIf="
                        spreadForm.get('spread')?.invalid &&
                        spreadForm.get('spread')?.touched
                      "
                      class="text-red-500 text-xs">
                      <div
                        *ngIf="spreadForm.get('spread')?.errors?.['required']">
                        {{ 'shared:isRequired' | translate }}
                      </div>
                      <div *ngIf="spreadForm.get('spread')?.errors?.['min']">
                        {{ 'settingsCustomSpread:spreadMinValue' | translate }}
                      </div>
                      <div *ngIf="spreadForm.get('spread')?.errors?.['max']">
                        {{ 'settingsCustomSpread:spreadMaxValue' | translate }}
                      </div>
                      <div
                        *ngIf="spreadForm.get('spread')?.errors?.['pattern']">
                        {{ 'editCustomSpread:twoDecimals' | translate }}
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="defaultSpread !== null"
                    class="text-sm text-gray-600 mt-2">
                    {{ 'editCustomSpread:defaultSpread' | translate }}
                    {{ defaultSpread }}%
                  </div>
                </div>

                <div
                  class="bg-orange-200 border-orange-300 mt-4 p-4 bg-amber-100 border border-amber-300 rounded-md flex items-start">
                  <mat-icon class="text-amber-500 mr-2">warning</mat-icon>
                  <div>
                    <p class="text-sm">
                      {{ 'editCustomSpread:applyMessage' | translate }}
                      <span
                        class="text-blue-500 cursor-pointer hover:underline ml-2"
                        (click)="toggleSpreadForm()">
                        {{ 'editCustomSpread:useDefaultSpread' | translate }}
                      </span>
                    </p>
                  </div>
                </div>
              </form>
            </div>
            <mat-error
              *ngIf="
                payment.controls['amount'].errors &&
                payment.controls['amount'].touched
              ">
              <span
                class="text-sm"
                *ngIf="payment.controls['amount'].errors['min']">
                <strong>{{
                  'studentPaymentV2:amountToReceiveMinValue' | translate
                }}</strong>
              </span>

              <span
                class="text-sm"
                *ngIf="payment.controls['amount'].errors['max']">
                <strong>{{
                  'studentPaymentV2:amountToReceiveMaxValue' | translate
                }}</strong>
              </span>
            </mat-error>
          </div>
        </form>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="flex justify-center">
        <mat-progress-spinner
          *ngIf="loading"
          [diameter]="40"
          [mode]="'indeterminate'"></mat-progress-spinner>
      </div>

      <div *ngIf="!loading && paymentRequest">
        <h1>
          {{ 'studentPaymentV2:studentPayment' | translate }} #{{
            paymentRequest.paymentRequestId
          }}
        </h1>
        <table class="w-2/4 mt-5">
          <tbody class="text-lg">
            <tr>
              <td>
                {{ 'createRequestMoney:orderInputProviderName' | translate }}:
              </td>
              <td class="font-bold">
                {{ paymentRequest.order?.providerName }}
              </td>
            </tr>
            <tr>
              <td>{{ 'paymentRequest:invoiceId' | translate }}:</td>
              <td class="font-bold">{{ paymentRequest.order?.orderId }}</td>
            </tr>
            <tr>
              <td>{{ 'paymentRequest:column2' | translate }}:</td>
              <td class="font-bold">
                {{ paymentRequest.payment?.amount | currency }}
                {{ paymentRequest.payment?.currency }}
              </td>
            </tr>
            <tr>
              <td>{{ 'createRequestMoney:studentInputName' | translate }}:</td>
              <td class="font-bold">
                {{ paymentRequest.student?.firstname }}
                {{ paymentRequest.student?.lastname }}
              </td>
            </tr>
            <tr>
              <td>
                {{ 'createRequestMoney:studentInputCountry' | translate }}:
              </td>
              <td class="font-bold">
                {{
                  'country:' + paymentRequest.student?.country?.toUpperCase()
                    | translate
                }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="mt-10 flex">
          <div class="flex items-center ml-4 mr-6">
            <i class="fa-solid fa-circle-bolt text-green-500 text-5xl"></i>
          </div>
          <div>
            <div>
              <span class="text-lg font-bold">{{
                'paymentRequest:linkReady' | translate
              }}</span>
            </div>
            <div>{{ 'paymentRequest:linkReadySub' | translate }}</div>
          </div>
        </div>

        <div class="flex mt-5">
          <div
            class="bg-gray-100 rounded-3xl p-5 cursor-pointer"
            matTooltip="{{ tooltipMessage | translate }}"
            [matTooltipPosition]="'above'"
            #tooltipUrl="matTooltip"
            (click)="
              copyToClipboard(paymentRequest.paymentLinkUrl, tooltipUrl)
            ">
            <span>{{ paymentRequest.paymentLinkUrl }}</span>
          </div>
          <div
            class="flex items-center ml-4 p-5 cursor-pointer"
            matTooltip="{{ tooltipMessage | translate }}"
            [matTooltipPosition]="'above'"
            #tooltipCopy="matTooltip"
            (click)="
              copyToClipboard(paymentRequest.paymentLinkUrl, tooltipCopy)
            ">
            <i class="fa-regular fa-copy text-2xl"></i>
          </div>
          <div
            class="flex items-center p-5 cursor-pointer"
            (click)="openPaymentLink(paymentRequest.paymentLinkUrl)">
            <i class="fa-regular fa-external-link text-2xl"></i>
          </div>
        </div>
        <div class="mt-10 flex gap-4">
          <button
            mat-stroked-button
            color="primary"
            class="rounded-full"
            (click)="
              showPaymentRequestFeatureFlag
                ? matDialogService.studentPayment()
                : matDialogService.requestMoney()
            ">
            <i class="fa-regular fa-plus mr-2"></i>
            {{ 'studentPaymentV2:createAnotherStudentPayment' | translate }}
          </button>

          <button
            mat-stroked-button
            color="primary"
            class="rounded-full"
            (click)="redirectToPaymentDetails()">
            <i class="fa-regular fa-eye mr-2"></i>
            {{ 'studentPaymentV2:viewStudentPayments' | translate }}
          </button>
        </div>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
